export interface AgentSettings {
  fanMaxSlope: number; //fanMaximumSlope
  fanMinΣ: number; //steepSlopes
  fanMaxΣ: number; //lowSlopes
  fanExponent: number; //skewFanningToLowSlopes
  maxSpawns: number; //maxSpawnsAllowed
  depositionMultiplier: number;
  erosionMultiplier: number;
  lossPercent: number; //maxLossPer45DegreeTurn
  minInitDepth: number; //minInitiationDepth
  removeRandomness: boolean;
  showAgents: boolean;
}

// agent-settings-metadata.ts
export interface AgentSettingMetadata {
  label: string;
  tooltip: string;
  unit?: string;
}

export interface AgentSettingMetadata {
  label: string;
  tooltip: string;
  unit?: string;
}

export const AGENT_SETTINGS_METADATA: Partial<Record<
  keyof AgentSettings,
  AgentSettingMetadata
>> = {
  fanMaxSlope: {
    label: 'Fan Maximum Slope (Degrees)',
    tooltip: 'Slope below which fanning behavior is desired',
    unit: '°',
  },
  fanMinΣ: {
    label: 'Steep Slopes',
    tooltip:
      'Confines fanning on high/steep slopes. Higher values increase spread.',
  },
  fanMaxΣ: {
    label: 'Low Slopes',
    tooltip:
      'Confines fanning on low/shallow slopes. Higher values increase spread.',
  },
  fanExponent: {
    label: 'Skew Fanning to Low Slopes',
    tooltip: 'Adjusts the relationship between slope and spread. 1 = linear, >1 = exponential, <1 = logarithmic.',
  },
  maxSpawns: {
    label: 'Maximum Spawns Allowed',
    tooltip: "The maximum number of generations of spawned agents during spread.",
  },
  depositionMultiplier: {
    label: 'Deposition Multiplier',
    tooltip: "Scales the deposition value for an agent during erosion/deposition.",
    unit: 'x',
  },
  erosionMultiplier: {
    label: 'Erosion Multiplier',
    tooltip: "Scales the erosion value for an agent during erosion/deposition.",
    unit: 'x',
  },
  minInitDepth: {
    label: 'Minimum Initiation Depth (meters)',
    tooltip: "The minium amount of scoured mass added to agents as they are placed initially.",
    unit: 'm',
  },
  lossPercent: {
    label: 'Max Loss per 45° Turn',
    tooltip: 'Maximum mass loss per sharp turn',
  },
};
